import { Channel, MessageType } from '../../domain';

export const aggregateChannelIds = (
  messageTypes: MessageType[] = [],
  channels: Channel[] = [],
): Set<Channel['id']> => {
  const channelIds = new Set<Channel['id']>();

  messageTypes.forEach((messageType) => channelIds.add(messageType.messageChannelId));

  channels.forEach((channel) => channelIds.add(channel.id));

  return channelIds;
};
